import { ListItemText, MenuItem, SelectProps } from '@mui/material'
import { useCallback } from 'react'
import { Checkbox } from 'src/components/checkbox'
import { Select } from 'src/components/select'
import { Colors } from 'src/components/theme'

export type CheckboxSelectOption<T> = {
  value: T
  label: string
}

type CheckboxSelectProps<T> = { options: CheckboxSelectOption<T>[] } & Omit<
  SelectProps<T[]>,
  'multiple' | 'renderValue' | 'variant'
>

export const CheckboxSelect = <T extends string | number>({ options, value, ...rest }: CheckboxSelectProps<T>) => {
  const getLabel = useCallback((currentValue: T) => options.find((opt) => opt.value === currentValue)?.label, [options])

  return (
    <Select
      {...rest}
      multiple
      value={value ?? []}
      renderValue={(selected) => selected.map(getLabel).join(', ')}
      variant="standard">
      {options.map((item, index) => {
        const isSelected = value ? value.findIndex((x) => x === item.value) > -1 : false
        const isLast = index === options.length - 1
        return (
          <MenuItem
            key={String(item.value)}
            value={String(item.value)}
            style={{
              backgroundColor: 'white',
              paddingLeft: 0,
              paddingRight: 0,
              borderBottom: isLast ? 0 : `1px solid ${Colors.borderInputHover}`,
            }}>
            <Checkbox
              checked={isSelected}
              color="primary"
              sx={{
                '&.Mui-checked': {
                  color: Colors.blueDark,
                },
              }}
            />
            <ListItemText primary={item.label} />
          </MenuItem>
        )
      })}
    </Select>
  )
}
